import { render, staticRenderFns } from "./EntranceAlert.vue?vue&type=template&id=660cf0b9&scoped=true&"
import script from "./EntranceAlert.vue?vue&type=script&lang=js&"
export * from "./EntranceAlert.vue?vue&type=script&lang=js&"
import style0 from "./EntranceAlert.vue?vue&type=style&index=0&id=660cf0b9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "660cf0b9",
  null
  
)

export default component.exports